import PropTypes from 'prop-types';

export const BatchSinglePropType = PropTypes.shape({
  fulfillmentPlanSetId: PropTypes.string,
  name: PropTypes.string,
  shipmentCount: PropTypes.number,
  createDate: PropTypes.string,
  completed: PropTypes.number,
  errors: PropTypes.number,
  total: PropTypes.number,
  warnings: PropTypes.number,
});

/**
 * @typedef {object} BatchSinglePropType
 * @property {string} fulfillmentPlanSetId
 * @property {string} name
 * @property {number} shipmentCount
 * @property {string} createDate
 * @property {number} completed
 * @property {number} errors
 * @property {number} total
 * @property {number} warnings
 */
